import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {AppFileItemContainerModel} from '../../../../../models/aggregates/app-file-item';

@Injectable({providedIn: 'root'})
export class AppFileItemLoginEpService extends BaseApiTemplateService<AppFileItemContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'app-file-items/login-entity-ep';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'app-file-items/login-entity-ep';
    this.httpClient = http;
  }

}
